(function () {
    'use strict';

    angular.module('ib-reusable-components-module', [
        'ib-MmB-modal-module',
        'ib-validators-module',
        'ib-mmb-main-footer-module',
        'ib-box-module',
        'ib-view-more-module',
        'ib-anonymous-search-module',
        'ib-equal-height-module',
        'ib-collapse-details-module',
        'ib-MmB-segment-details-module',
        'ib-MmB-flights-card-module',
        'ib-MmB-hotel-card-module',
        'ib-MmB-experience-card-module',
        'ib-MmB-transfer-card-module',
        'ib-MmB-car-card-module',
        'ib-slide-toggle-module',
        'ib-hover-opacity-module',
        'ib-alert-hide-module',
        'ib-accordion',
        'ib-popover-module',
        'ib-limit-years-datepicker-module',
        'ib-comment-module',
        'ib-banner-module',
        'ib-load-images-module',
        'ib-on-hold-header-module',
        'ib-login-access-old-module',
        'ib-scroll-module',
        'ib-ancillaries-module',
        'ib-box-module-link-module',
        'ib-order-summary-ancillaries-module',
        'ib-apis-form-module',
        'ib-passenger-birth-date-module',
        'ib-expiry-date-module',
        'ib-booking-name',
        'ib-http-services-module',
        'ib-content-parser-module',
        'ib-validators-module',
        'ib-tabs',
        'ib-focusin',
        'ib-keep-alive-module',
        'ib-partner-box-module',
        'ib-datepicker',
        'ib-dropdown-select',
        'ib-slick-carousel-module',
        'ib-rangeslider',
        'ib-monetate-module',
        'ib-mmb-dash-item',
        'ib-MmB-refund-information-module',
        'ib-MmB-voucher-refund-module',
        'ib-MmB-refund-doubts-and-rights-module',
        'ib-MmB-cash-refund-module',
        'ib-MmB-voucher-refund-breakdown-module',
        'ib-MmB-doubts-and-rights-vert-module',
        'ib-MmB-voucher-refund-summary-module',
        'ib-Mmb-voucher-refund-confirmation-module',
        'ib-Mmb-cash-refund-confirmation-module',
        'ib-MmB-cash-refund-breakdown-module',
        'ib-MmB-change-flights-service',
        'ib-MmB-documents-card-module'
    ]);
})();
